"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseTextWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var CollapseTextWidget = /** @class */ (function (_super) {
    __extends(CollapseTextWidget, _super);
    function CollapseTextWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.collapseElement = _this.collapseElement.bind(_this);
        _this.state = {
            collapse: _this.props.defaultCollapseState,
            display: _this.props.defaultDisplayState
        };
        return _this;
    }
    CollapseTextWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "btn-text ".concat(this.state.collapse), onClick: this.collapseElement, onKeyDown: this.collapseElement, tabIndex: 0, children: this.props.summary }), (0, jsx_runtime_1.jsx)("div", { className: "collapsible ".concat(this.state.display === "none" ? "d-none" : "d-block"), children: this.props.p })] }));
    };
    CollapseTextWidget.prototype.collapseElement = function (event) {
        if (event.target.className.includes("notCollapsed")) {
            this.setState({ collapse: "collapsed", display: "block" });
        }
        if (event.target.className.includes("collapsed")) {
            this.setState({ collapse: "notCollapsed", display: "none" });
        }
    };
    return CollapseTextWidget;
}(React.Component));
exports.CollapseTextWidget = CollapseTextWidget;
//# sourceMappingURL=CollapseTextWidget.js.map